import { Suspense, lazy, memo } from 'react'
import { useWireValue } from '@forminator/react-wire'
import { ably as storeAbly } from '@store/realtime'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import CircleSpinner from '@components/shared/CircleSpinner'
import config from '@/config'
import AppWithUser from './AppWithUser'
import { AblyProvider } from 'ably/react'
import AppWithDataRouter from '@/app/AppWithDataRouter'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            
            // Customize the error boundary behavior
            onError: error => {
                
                // Silently ignore AbortErrors
                if (error.name === 'CanceledError' || error.name === 'AbortError')
                    return
                
                // Optionally log other errors
                console.error('Query failed:', error)
                
            },
            
            // Prevent queries from entering error state on abort
            retry: (failureCount, error) => {
                
                if (error.name === 'CanceledError' || error.name === 'AbortError')
                    return false // Don't retry on abort
                
                // Retry other errors up to 3 times
                return failureCount < 3
                
            },
            
        },
    },
})

const Main = () => {
    
    const ably = useWireValue(storeAbly, null)
    
    // @todo @featureflag
    if (config.enableDataRouter)
        return <AppWithDataRouter />
    
    const App = lazy(() => import('./AppRoutes'))
    
    const component = (
        <Suspense fallback={<CircleSpinner className="absolute-centered" />}>
            <QueryClientProvider client={queryClient}>
                <App>
                    <AppWithUser />
                </App>
            </QueryClientProvider>
        </Suspense>
    )
    
    if (ably)
        return (
            <AblyProvider client={ably}>
                {component}
            </AblyProvider>
        )
    
    return component
    
}

export default memo(Main)
